// src/services/callableFunctions.js
//
// Single entry point for the callable Cloud Functions added in
// almada §9.2. Mirrors the lazy-init pattern in reciteService.js so the
// Functions SDK is only loaded when first used and so test harnesses
// that mock `firebase/functions` keep working.

import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';
import app from '../firebase/config';

const FUNCTIONS_REGION = 'europe-west1';

let _fns = null;
function fns() {
  if (!_fns) {
    _fns = getFunctions(app, FUNCTIONS_REGION);
    const flag = process.env.REACT_APP_USE_FUNCTIONS_EMULATOR;
    if (flag === 'true' || flag === '1') {
      try {
        connectFunctionsEmulator(_fns, 'localhost', 5001);
      } catch (_) {
        /* already connected */
      }
    }
  }
  return _fns;
}

const cache = new Map();
function call(name) {
  if (!cache.has(name)) cache.set(name, httpsCallable(fns(), name));
  return cache.get(name);
}

export const notifyUser = (data) => call('notifyUser')(data).then((r) => r.data);
export const logAuditEvent = (data) =>
  call('logAuditEvent')(data).then((r) => r.data);
export const logLoginEvent = (data = {}) =>
  call('logLoginEvent')(data).then((r) => r.data);
export const approveSuggestionCallable = (data) =>
  call('approveSuggestion')(data).then((r) => r.data);
export const dismissSuggestionCallable = (data) =>
  call('dismissSuggestion')(data).then((r) => r.data);
